import { loadGtag } from '@repo/ui/lib/gtag';
import { useEffect } from 'react';
import { GA_MEASUREMENT_ID } from '@/lib/analytics/ga-measurement-id';
import { useCookieConsentStore } from '@/stores/use-cookie-consent-store';

/**
 * Loads Google Analytics 4 once this browser accepts analytics cookies, the same
 * gate PostHog uses. Rejecting goes through `stopAnalytics()` in `./consent`,
 * which disables gtag and clears the `_ga*` cookies.
 *
 * When `VITE_GA_MEASUREMENT_ID` is unset (local dev), nothing loads.
 */
export function GoogleAnalytics() {
    const analyticsAllowed = useCookieConsentStore((state) => state.analytics === true);

    useEffect(() => {
        if (!GA_MEASUREMENT_ID || !analyticsAllowed) return;
        loadGtag(GA_MEASUREMENT_ID);
    }, [analyticsAllowed]);

    return null;
}
